// extracted by mini-css-extract-plugin
module.exports = {"toolbar-section":"TableToolbar_toolbar-section__WkRvF","custom-position":"TableToolbar_custom-position__tUZcQ"};